// extracted by mini-css-extract-plugin
export var hasGlMessage = "Hero-module--hasGlMessage--c0a84";
export var hero = "Hero-module--hero--35b29";
export var heroMainFeatures = "Hero-module--heroMainFeatures--6d209";
export var image = "Hero-module--image--26810";
export var petSpeciesSelector = "Hero-module--petSpeciesSelector--d7453";
export var subtitle = "Hero-module--subtitle--be995";
export var title = "Hero-module--title--7f078";
export var trustPilotReviews = "Hero-module--trustPilotReviews--dbfd1";